












































import Vue from "vue";
import SharedFilesService from "@/services/sharedFilesService";
import { Item } from "@/models/sharedFiles";
import AgreementService from "@/services/agreementService";
import AdminService from "@/services/adminService";

export default Vue.extend({
  data() {
    return {
      data: [] as Item[],
      isLoaded: false,
      deleting: false
    };
  },
  name: "Folders",
  props: ["name"],

  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoaded = true;
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const sharedFilesService = new SharedFilesService(jwt);
        const formData = new FormData();
        formData.append("folder_name", this.$props.name);
        const response = await sharedFilesService.getFilesInFolders(formData);
        if (response !== undefined && response !== null) {
          if (response.data !== undefined && response.data !== null) {
            this.data = response.data.data;
          }
        }
      }
      this.isLoaded = false;
    },
    async deleteFile(e, name) {
      e.preventDefault();
      if (this.deleting) {
        return;
      }
      if (confirm("Are you sure you want to delete file " + name)) {
        this.isLoaded = true;
        const jwt = window.localStorage.getItem("jwt");
        if (jwt) {
          try {
            const sharedFilesService = new SharedFilesService(jwt);
            const formData = new FormData();
            formData.append("folder_name", this.$props.name.trim());
            formData.append("file_name", name);
            const response = await sharedFilesService.deleteFile(formData);
            if (response && response.status == 200) {
              if (response.data) {
                alert(response.data);
                await this.getList();
                this.isLoaded = false;
              }
            }
          } catch (e) {
            alert(JSON.stringify(e.response.data));
            this.isLoaded = false;
          }
        }
      }
    },
    async goToUploadFile() {
      await this.$router.push("/upload-file/" + this.name);
    }
  }
});
